import axios from "axios";
import store from "@/store/store";
import {authService} from '@/modules/auth/services/authService.js'

let HTTP;

HTTP = axios.create({
  baseURL:  window.vue_config.VUE_APP_API_URL + 'v2/',
  withCredentials: true
});

const get = (route, params, paramsSerializer) => {
  return HTTP.get(route, { params, paramsSerializer }).then(res => res.data);
};

const post = (route, params) => {
  return HTTP.post(route, params).then(res => res.data);
};

const put = (route, params) => {
  return HTTP.put(route, params).then(res => res.data);
};

let remove = (route, params) => {
  return HTTP.delete(route, params).then(res => res.data);
};

HTTP.interceptors.request.use(
  config => {
    // Do something before request is sent
    const token = store.getters["auth/token"];
    const staff = store.getters["accountModule/staff"];
    const profile = store.getters["accountModule/profile"];
    const isCollaborator = store.getters["accountModule/isCollaborator"];

    config.headers["x-mobile-app"] = store.getters["isMobileApp"];
    config.headers["x-app-name"] = "Frontage";
    if (!config.params){
      config.params = {}
    }

    if (staff && profile && staff.uid != profile.staff.uid){
      config.params.context_staff = staff.uid
    }

    if (isCollaborator){
      config.params.teams_view_filter = store.getters["accountModule/teamsViewFilter"]
    }

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (config.url.includes('platform/v1/') || config.new_api || config.params.new_api || (config.data && config.data.new_api)) {
      config.baseURL = window.vue_config.VUE_APP_API_URL;
    }

    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    // Do something with response error
    if (error.response && error.response.status === 401) {
      let resp = await authService.getToken()
      if (resp.success){
        store.commit('auth/saveToken',resp.jwt)
        error.config.headers["Authorization"] = `Bearer ${resp.jwt}`;
        return HTTP(error.config);
      } else {
        authService.logout();
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
);


export default {
  get,
  post,
  put,
  remove
};
